import React, { FC } from 'react';
import styled from 'styled-components/macro';
import { Controller } from 'react-hook-form';
import media from 'styles/media';
import * as MESSAGES from 'constants/messages';
import { NO_SELECT_NUMBER } from 'constants/form';
import {
  ProfileFormItems,
  ProfileFormValues,
  ProfileFormControl,
} from 'types/profile';
import { Selectbox } from 'components/atoms';
import { Field } from 'components/molecules';

type CareerPreferredMonthlyUnitPriceFormFieldProps = {
  error: string | undefined;
  control: ProfileFormControl<{
    career: Pick<ProfileFormValues['career'], 'preferredMonthlyUnitPriceId'>;
  }>;
  preferredMonthlyUnitPrices: ProfileFormItems['preferredMonthlyUnitPrices'];
};

const StyledSelectbox = styled(Selectbox)`
  width: 368px;

  ${media.mobile} {
    width: 100%;
  }
`;

const CareerPreferredMonthlyUnitPriceFormField: FC<CareerPreferredMonthlyUnitPriceFormFieldProps> = props => {
  const { error, control, preferredMonthlyUnitPrices } = props;

  return (
    <Field
      label={`${MESSAGES.PROFILE.FIELD.CAREER_PREFERRED_MONTHLY_UNIT_PRICE.LABEL}${MESSAGES.PROFILE.FIELD.CAREER_PREFERRED_MONTHLY_UNIT_PRICE.LABEL_NOTE}`}
    >
      <Controller
        control={control}
        name="career.preferredMonthlyUnitPriceId"
        render={innerProps => (
          <StyledSelectbox
            value={innerProps.value}
            error={error}
            options={[
              {
                id: NO_SELECT_NUMBER,
                name: MESSAGES.COMMON.SELECT_BOX.NO_SELECT,
              },
              ...preferredMonthlyUnitPrices,
            ]}
            aria-label={
              MESSAGES.PROFILE.FIELD.CAREER_PREFERRED_MONTHLY_UNIT_PRICE.LABEL
            }
            onChange={innerProps.onChange}
            onBlur={innerProps.onBlur}
          />
        )}
      />
    </Field>
  );
};

export default CareerPreferredMonthlyUnitPriceFormField;
